import React, { useState } from "react";
import Table from "../../../../common/element/Table";
import Button from "../../../../common/element/Buttons";
import Checkbox from "../../../../common/element/Checkbox";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../../common/Common/DeleteModal";
import { useDispatch } from "react-redux";
import { deleteCoach, getCoachList } from "../../../../redux/Coach/coachSlice";
import SweetAlertService from "../../../../common/SweetAlert/SweetAlert";
import ThreeDotBouncingLoader from "../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import CommonIconButton from "../../../../common/icons/CommonIconButton";
const { Tr, Th, Td, THead, TBody } = Table;

const CoachesList = (props) => {
  const [mainCheck, setMainCheck] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [isOpen, setIsopen] = useState(false)
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState(null); // 👈 Selected Coach ID

  const dispatch = useDispatch();
  // const sampleData = props?.sampleData || [];

  const onCheckboxChange = (checked, item) => {
    if (item === "mainCheck") {
      setMainCheck(checked);
      setCheckedItems(checked ? props?.sampleData || [] : []);
    } else {
      if (checked) {
        setCheckedItems([...checkedItems, item]);
      } else {
        // items in API use coach_id as unique id
        setCheckedItems(checkedItems.filter((i) => i.coach_id !== item.coach_id));
      }
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;

    const result = await dispatch(deleteCoach(deleteId));

    // ✅ If delete success
    if (result?.meta?.requestStatus === "fulfilled") {
      SweetAlertService.showSuccess({
        title: "Deleted!",
        message: "Coach has been deleted successfully.",
      });

      // refresh list
      dispatch(
        getCoachList({
          page: props?.currentPage || 1,
          limit: props?.pageLimit || 10,
          search: props?.searchValue || "",
        })
      );

      setIsopen(false);
    }

    // ❌ If delete failed
    if (result?.meta?.requestStatus === "rejected") {
      SweetAlertService.showError({
        title: "Error!",
        message: result?.payload || "Failed to delete coach. Please try again.",
      });
    }
  };


  return (
    <div className="border rounded-lg border-gray-200">
      <Table>
        <THead>
          <Tr className="text-start">

            <Th >
              {/* <Checkbox
              checked={mainCheck}
              className="p-2"
              onChange={(e) => onCheckboxChange(e, "mainCheck")}
            /> */}
              S No.</Th>
            <Th>Name</Th>
            <Th>Email</Th>
            <Th>Mobile</Th>
            <Th>City</Th>
            <Th>State</Th>
            <Th>Action</Th>
          </Tr>
        </THead>

        <TBody>
          {props?.loading ? (
            <Tr>
              <Td colSpan={8} className="py-10 text-center">
                <ThreeDotBouncingLoader />
              </Td>
            </Tr>
          ) : props?.sampleData && props?.sampleData.length > 0 ? (
            props.sampleData.map((item, index) => (
              <Tr key={item.coach_id} className="text-center">

                {/* Checkbox + Index */}
                <Td>
                  {/* <Checkbox
            checked={checkedItems.some((i) => i.coach_id === item.coach_id)}
            onChange={(e) => onCheckboxChange(e, item)}
            className="p-2"
          /> */}
                  {String((props?.currentPage - 1) * props?.pageLimit + (index + 1)).padStart(2, "0")}
                </Td>

                {/* Name */}
                <Td>
                  {(item.user && `${item.user.first_name} ${item.user.last_name}`) ||
                    item.display_name ||
                    "-"}
                </Td>

                {/* Email */}
                <Td>{(item.user && item.user.email) || "-"}</Td>

                {/* Phone */}
                <Td>{item.mobile_number || item.work_phone || "-"}</Td>

                {/* City */}
                <Td>{item.city?.city_name || "-"}</Td>

                {/* State */}
                <Td>{item.state?.state_name || "-"}</Td>

                {/* Actions */}
                <Td>
                  <div className="flex gap-1">

                    {/* View Button */}
                    <CommonIconButton
                      type="view"
                      onClick={() => navigate(`/coaches/view?id=${item.coach_id}&coachName=${item.user.first_name} ${item.user.last_name}`)}
                    />
                    {/* Delete Button */}
                    <CommonIconButton
                      type="delete"
                      onClick={() => {
                        setDeleteId(item.coach_id);
                        setIsopen(true);
                      }}
                    />

                  </div>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={8} className="text-center text-gray-500 py-6 text-sm">
                No matching records found
              </Td>
            </Tr>
          )}
        </TBody>

      </Table>
      <DeleteModal
        dialogOpen={isOpen}
        onDialogClose={() => setIsopen(false)}
        onConfirm={handleDelete}
        title="Are you sure you want to delete?"
        subtitle="This action cannot be undone."
      />
    </div>
  );
};

export default CoachesList;
